import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import LinearProgress from "@material-ui/core/LinearProgress";
import { set } from "date-fns";
import Exitoso from "../Exitoso";
import Error from "../Error";

import { BASE_URL } from "../../../utils/index";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    "& > * + *": {
      marginTop: theme.spacing(2),
    },
  },
}));

export default function LoadingServicio(props) {
  // console.log(props.values);
  useEffect(() => {
    const requestHandle = async () => {
      //Data
      const {
        tipo,
        turno,
        destino,
        direccionHospital,
        fechaEnviar,
        idPrimerPaciente,
        primerPaciente,
        puebloPrimerPaciente,
        telfPrimerPaciente,
        telfPrimerPaciente2,
        direccionPrimerPaciente,
        NASS1,
        idSegundoPaciente,
        segundoPaciente,
        puebloSegundoPaciente,
        telfSegundoPaciente,
        telfSegundoPaciente2,
        direccionSegundoPaciente,
        NASS2,
        email,
        password,
        idCliente,
        idClienteSol,
        perfilLog,
        urgente,
        alta,
        ingres,
      } = props.values;
      //Fetch
      // console.log(props.values);
      let csrfToken = localStorage.getItem("csrfToken");
      console.log(csrfToken);

      let response = await fetch(`${BASE_URL}/pedirViaje`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "X-CSRF-TOKEN": csrfToken, // Adjuntar el token CSRF como encabezado
        },
        body: JSON.stringify({
          email: email,
          password: password,
          fecha: fechaEnviar,
          tipo: tipo,
          idPrimerPaciente: idPrimerPaciente,
          primerPaciente: primerPaciente,
          puebloPrimerPaciente: puebloPrimerPaciente.title,
          telfPrimerPaciente: telfPrimerPaciente,
          telfPrimerPaciente2:
            telfPrimerPaciente2 != "" ? telfPrimerPaciente2 : "NO",
          direccionPrimerPaciente: direccionPrimerPaciente,
          NASS1: NASS1,
          idSegundoPaciente: idSegundoPaciente,
          segundoPaciente: segundoPaciente,
          puebloSegundoPaciente: puebloSegundoPaciente.title,
          telfSegundoPaciente: telfSegundoPaciente,
          telfSegundoPaciente2:
            telfSegundoPaciente2 !== "" ? telfSegundoPaciente2 : "NO",
          direccionSegundoPaciente: direccionSegundoPaciente,
          NASS2: NASS2,
          direccionHospital: direccionHospital,
          idCliente: perfilLog == 5 ? idClienteSol.id : idCliente,
          turno: turno,
          destino: destino,
          urgente: urgente,
          alta: alta,
          ingres: ingres,
        }),
      });
      try {
        let response2 = await response.json();
        console.log(response2);
        const { message, id } = response2;
        if (message != undefined || message != null) {
          setStateComponent({
            ...stateComponent,
            isLoading: false,
            isSuccess: true,
            message: message,
          });
        } else {
          setStateComponent({
            ...stateComponent,
            isError: true,
          });
        }
      } catch (error) {
        console.log(error);
      }
    };

    requestHandle();
  }, []);

  const classes = useStyles();

  const [stateComponent, setStateComponent] = useState({
    isLoading: true,
    isSuccess: false,
    isError: false,
    message: "",
  });

  if (stateComponent.isLoading)
    return (
      <div className={classes.root}>
        <LinearProgress />
      </div>
    );

  if (stateComponent.isSuccess) {
    return <Exitoso message={stateComponent.message} />;
  }

  if (stateComponent.isError) {
    return <Error />;
  }
}
